"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTransaction = void 0;
const enums_1 = require("../../global/enums");
const getHostResponseCodeMessage_1 = require("./getHostResponseCodeMessage");
const combineResponseMessages = (hostResponseMessage, expressResponseMessage) => {
    if (expressResponseMessage) {
        throw new Error(`${expressResponseMessage}: ${hostResponseMessage}`);
    }
    else {
        throw new Error(hostResponseMessage);
    }
};
const overrideExpressResponseMessage = (expressResponseCode, expressResponseMessage) => {
    switch (expressResponseCode) {
        case enums_1.ExpressResponseCodes.DUPLICATE:
            expressResponseMessage =
                'Duplicate transaction by the same card number and amount detected in the last 25 transactions. Please try again with a different card';
            break;
        default:
    }
    return expressResponseMessage;
};
const overrideLog = (log) => {
    if (log === 'Incomplete Contactless Cardread. Please try again.') {
        return 'Tap failed. Please hold card on terminal and wait for beep sound.';
    }
    if (log === 'Contactless MSD is not supported') {
        return 'Card does not support contactless payment. Insert or swipe card instead.';
    }
    return log;
};
const validateTransaction = (transactionResponse) => {
    if (!transactionResponse) {
        throw new Error('Transaction is not successful. No response from the terminal.');
    }
    if (transactionResponse.statusCode === enums_1.WorldpayResponseStatuses.RESPONSE_NOT_READY) {
        throw new Error('Transaction is not ready. Please try to submit the transaction again.');
    }
    const isTransactionNotApproved = 'isApproved' in transactionResponse.data && !transactionResponse.data.isApproved;
    const isTransactionCancelled = 'approvedAmount' in transactionResponse.data && transactionResponse.data.approvedAmount === 0;
    if (isTransactionNotApproved || isTransactionCancelled) {
        const transactionData = transactionResponse.data;
        const { expressResponseCode, logs, hostResponseMessage, hostResponseCode } = transactionData._processor;
        let expressResponseMessage = transactionData._processor.expressResponseMessage;
        expressResponseMessage = overrideExpressResponseMessage(expressResponseCode, expressResponseMessage);
        if (hostResponseMessage) {
            const errorMessage = combineResponseMessages(hostResponseMessage, expressResponseMessage);
            throw new Error(errorMessage);
        }
        if (hostResponseCode) {
            const hostResponseMessage = (0, getHostResponseCodeMessage_1.getHostResponseCodeMessage)(hostResponseCode);
            if (hostResponseMessage) {
                const errorMessage = combineResponseMessages(hostResponseMessage, expressResponseMessage);
                throw new Error(errorMessage);
            }
        }
        else if (expressResponseMessage) {
            throw new Error(expressResponseMessage);
        }
        let errorMessage = 'Transaction is cancelled/declined. Please try to submit the transaction again.';
        if (logs && logs.length > 0) {
            let firstLog = logs[0] || '';
            firstLog = firstLog.split(':')[0].trim();
            errorMessage = overrideLog(firstLog);
        }
        throw new Error(errorMessage);
    }
    return transactionResponse;
};
exports.validateTransaction = validateTransaction;
//# sourceMappingURL=validateTransaction.js.map